import "./App.css";
import "./index.css";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme } from "@mui/material";
import { ThemeProvider } from "@emotion/react";
import { RouterProvider } from "react-router-dom";
import { useAuth } from "./Hooks/useAuth";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import router from "./router";

let theme = createTheme({
  palette: {
    primary: {
      main: "#1a4079",
    },
  },
});

theme = createTheme(theme, {
  // Custom colors created with augmentColor go here
  palette: {
    warning2: theme.palette.augmentColor({
      color: {
        main: "#7800a8",
      },
      name: "warning2",
    }),
    warning3: theme.palette.augmentColor({
      color: {
        main: "#3e0057",
      },
      name: "warning3",
    }),
  },
});

function App() {
  const { login } = useAuth();

  return (
    <div style={{ backgroundColor: "#f6f0e8", minHeight: "100vh" }}>
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <RouterProvider router={router(login)}></RouterProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
